import React, {
  Fragment as _,
  createContext,
  useState,
  useContext,
} from 'react';
import { Box } from 'theme-ui';
import { AssessmentContext } from 'components/Module/AssessmentContainer';

const AssessmentQuestionOptions = ({ children, ...props }) => {
  const assessmentContext = useContext(AssessmentContext);

  const { answersWrappingAlignment = 'center' } = assessmentContext;

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent:
          answersWrappingAlignment === 'center' ? 'center' : 'flex-start',
      }}
    >
      {[...children].map((child, index) => {
        return React.cloneElement(child, {
          numOptions: children.length,
          index,
        });
      })}
    </Box>
  );
};

export default AssessmentQuestionOptions;
